/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { JourneyForUserSegment } from './JourneyForUserSegment';
import {
    JourneyForUserSegmentFromJSON,
    JourneyForUserSegmentFromJSONTyped,
    JourneyForUserSegmentToJSON,
    JourneyForUserSegmentToJSONTyped,
} from './JourneyForUserSegment';

/**
 * 
 * @export
 * @interface JourneyForUser
 */
export interface JourneyForUser {
    /**
     * 
     * @type {string}
     * @memberof JourneyForUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof JourneyForUser
     */
    name: string;
    /**
     * Adaptive track this journey represents (Play, Drop-In, Social, Collect).
     * @type {string}
     * @memberof JourneyForUser
     */
    track?: string;
    /**
     * The journey's segments in track order.
     * @type {Array<JourneyForUserSegment>}
     * @memberof JourneyForUser
     */
    segments: Array<JourneyForUserSegment>;
}

/**
 * Check if a given object implements the JourneyForUser interface.
 */
export function instanceOfJourneyForUser(value: object): value is JourneyForUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('segments' in value) || value['segments'] === undefined) return false;
    return true;
}

export function JourneyForUserFromJSON(json: any): JourneyForUser {
    return JourneyForUserFromJSONTyped(json, false);
}

export function JourneyForUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): JourneyForUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'track': json['track'] == null ? undefined : json['track'],
        'segments': ((json['segments'] as Array<any>).map(JourneyForUserSegmentFromJSON)),
    };
}

export function JourneyForUserToJSON(json: any): JourneyForUser {
    return JourneyForUserToJSONTyped(json, false);
}

export function JourneyForUserToJSONTyped(value?: JourneyForUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'track': value['track'],
        'segments': ((value['segments'] as Array<any>).map(JourneyForUserSegmentToJSON)),
    };
}

